<template>
  <div class="assessment">
    <div class="assessment_header">
      <div class="assessment_header_left" @click="$router.push({ path: '/multiomics' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>
    <div class="main">
      <div class="position">
        <div class="box">
          <p>人类的基因组与生俱来，很难随着时间改变。但人身处的环境却一直在变。基因因素和环境因素共同决定了一个人现在的状态：有没有生病？短期内容不容易生病？是胖子还是瘦子？喜欢吃甜还是吃辣？</p>
          <p>环境因素和基因相互作用，也相互制约。G6PD缺陷的人群，平时并不会与常人有什么差异，但在接触到某些特定物质（如蚕豆等）时会发生严重的溶血性贫血。若没有特殊的疾病，正常人群可以耐受130mg/dl的低密度脂蛋白胆固醇（LDL-C）水平，而在LDLR基因突变的人群中，100mg/dl以上的LDL-C水平即有可能造成严重的突发性心血管疾病。</p>
          <p>因此，单纯以遗传因素判定风险不够精准。在这个模块中，我们针对部分疾病提出了综合评估的方案，根据遗传因素、环境因素共同对{{ child === 1 ? '孩子' : '您' }}未来一段时间内重大疾病的发病风险做出预测，并提示相应的生活建议。</p>
        </div>
        <Btn :class="disable ? 'notclick' : ''" v-if="state === '3'" :btnData="{text: '申请测评'}" @btnClick="btnClickApply"></Btn>
        <Btn v-else-if="state === '2'" :btnData="{text: '立即测评'}" @btnClick="$router.push({ path: '/assessmentAppraisal' })"></Btn>
        <Btn v-else-if="state === '1' && child !== 1" :btnData="{text: '查看我的结果'}" @btnClick="$router.push({path: '/assessmentResult'})"></Btn>
        <Btn v-else-if="state === '1' && child === 1" :btnData="{text: '查看孩子的结果'}" @btnClick="$router.push({path: '/assessmentResult'})"></Btn>
        <p class="info">若{{ child === 1 ? '孩子' : '您' }}暂无数据，请联系客服</p>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import { Dialog } from 'vant'
export default {
  name: 'index',
  components: {
    Btn
  },
  data () {
    return {
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      disable: false,
      state: '' // 状态：1 ：存在结果（微信端直接显示结果） 2：微信端填写（微信端显示立即测评 ） 3：B端填写
    }
  },
  methods: {
    getintotype () {
      this.util.get(this.api.assessment_getintotype, '', (success) => {
        this.state = success.tag
      })
    },
    btnClickApply () {
      this.disable = true
      this.util.get(this.api.assessment_sendmail, '', (success) => {
        this.disable = false
        Dialog.alert({
          message: '已收到您的测评需求，请您耐心等待。'
        }).then(() => {
          this.$router.push({ path: '/home' })
        })
      })
    }
  },
  mounted () {
    this.getintotype()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .assessment {

    .assessment_header {
      width: 100%;
      height: pxToRem(447px);
      background: url("../../assets/images/assessment/assessment-1.png");
      background-size: cover;
      background-position: center;

      .assessment_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
        color: #fff;
      }
    }

    .main {
      width: 100%;
      padding: .15rem;

      .position {
        position: relative;
        z-index: 20;
        width: pxToRem(660px);
        margin: 0 auto;
        margin-top: pxToRem(-80px);

        .box {
          padding: .2rem;
          border-radius: pxToRem(25px);

          p {
            margin-bottom: pxToRem(40px);
            text-align: justify;

            &:last-child {
              margin: 0;
            }
          }
        }

        .info {
          text-align: center;
          font-size: pxToRem(18px);
          color: #929394;
          margin-top: pxToRem(20px);
        }
      }
    }
    .notclick {
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/assessment/index.vue